import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "mb-6 flex items-center gap-3" }
const _hoisted_3 = { class: "p-2 bg-[#22282F]/10 rounded-lg" }
const _hoisted_4 = {
  class: "flex gap-1 border-b border-gray-200 mb-6 overflow-x-auto",
  role: "tablist"
}
const _hoisted_5 = ["aria-selected", "data-tab", "onClick"]

import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { BellRing, ShieldAlert, Landmark } from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import AlertesSecuritePanel from '@/components/notifications/AlertesSecuritePanel.vue'
import ReceptionAtmPanel from '@/components/notifications/ReceptionAtmPanel.vue'
import { useAuthStore } from '@/store/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationsView',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

const onglets = [
  { id: 'securite', label: 'Alertes de sécurité', icon: ShieldAlert, section: 'securite' },
  { id: 'reception', label: 'Courriers reçus (ATM)', icon: Landmark, section: 'notifications' },
]

// Un profil restreint ne voit que les onglets de ses sections.
const ongletsVisibles = computed(() => onglets.filter((o) => authStore.canSection(o.section)))

const actif = computed(() => {
  const demande = String(route.query.onglet || '')
  return ongletsVisibles.value.find((o) => o.id === demande)?.id ?? ongletsVisibles.value[0]?.id
})

function choisir(id: string) {
  router.replace({ query: { ...route.query, onglet: id } })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(BellRing), { class: "w-7 h-7 text-[#22282F]" })
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-gray-900" }, "Notifications"),
            _createElementVNode("p", { class: "text-sm text-gray-500" }, "Qui est prévenu, et de quoi : alertes de sécurité et courriers reçus.")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ongletsVisibles.value, (onglet) => {
            return (_openBlock(), _createElementBlock("button", {
              key: onglet.id,
              type: "button",
              role: "tab",
              "aria-selected": actif.value === onglet.id,
              "data-tab": onglet.id,
              class: _normalizeClass([
            'px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px flex items-center gap-2 transition-colors',
            actif.value === onglet.id
              ? 'border-[#22282F] text-[#22282F]'
              : 'border-transparent text-gray-500 hover:text-[#22282F]',
          ]),
              onClick: ($event: any) => (choisir(onglet.id))
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(onglet.icon), { class: "w-4 h-4" })),
              _createTextVNode(" " + _toDisplayString(onglet.label), 1)
            ], 10, _hoisted_5))
          }), 128))
        ]),
        (actif.value === 'securite')
          ? (_openBlock(), _createBlock(AlertesSecuritePanel, { key: 0 }))
          : (actif.value === 'reception')
            ? (_openBlock(), _createBlock(ReceptionAtmPanel, { key: 1 }))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})